import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "./invoiceShared.scss";
import StateContext from "../../StateContext";

function InvoiceSharedHeader({
  languageLabel = "عربي",
  onLanguageToggle,
  onPrimaryClick,
  primaryType = "icon",
  primaryLabel = "Login",
  onShareClick,
  onLogoutClick,
}) {
  const appState = useContext(StateContext);
  const { t } = useTranslation();
  const logoutAriaLabel = t("invoice.logout", { defaultValue: "Log out" });
  return (
    <div className="invoice-shared-topbar">
      <div className="invoice-shared-top-actions d-flex justify-content-between align-items-center w-100">
        <span className="d-flex justify-content-start align-items-center w-100 gap-2">
          {primaryType === "icon" ? (
            <button className="invoice-shared-icon-btn" aria-label="Profile" type="button" onClick={onPrimaryClick}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2c-4.42 0-8 2.02-8 4.5 0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5C20 16.02 16.42 14 12 14Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          ) : (
            <button className="invoice-shared-text-btn" type="button" onClick={onPrimaryClick}>
              {primaryLabel}
            </button>
          )}

          {appState?.loggedIn && typeof onLogoutClick === "function" ? (
            <button
              className="invoice-shared-icon-btn me-3 mx-2"
              type="button"
              aria-label={logoutAriaLabel}
              onClick={onLogoutClick}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 17l5-5-5-5M21 12H9"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          ) : null}

          <button className={`invoice-shared-icon-btn ${!appState?.loggedIn ? "mx-2" : ""}`} aria-label="Share" type="button" onClick={onShareClick}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 3v10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              <path d="M8 7l4-4 4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              <rect x="4" y="11" width="16" height="10" rx="3" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          </button>
        </span>
        <button className="invoice-shared-lang-btn d-flex justify-content-center align-items-center w-25" type="button" onClick={onLanguageToggle}>
          {languageLabel}
        </button>
      </div>
    </div>
  );
}

export default InvoiceSharedHeader;
